@import "~swiper/swiper-bundle.min.css";
content-carousel {
  display: block;
  overflow: hidden;
}